module.exports = __webpack_public_path__ + "static/fcra-2018-19-q1-906c6ef2d428799c9248892566eeabfc.pdf";